module.exports = __webpack_public_path__ + "8895a29f3eb2e74582382ba626fa5439.svg";